import { render } from "./chartDef.vue?vue&type=template&id=8e1c64bc&scoped=true"
import script from "./chartDef.vue?vue&type=script&lang=js"
export * from "./chartDef.vue?vue&type=script&lang=js"

import "./chartDef.vue?vue&type=style&index=0&id=8e1c64bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1c64bc"]])

export default __exports__